import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { parseCurrentRemark } from './transactionConstants';

export default function TransactionRemarkModal({ open, row, onClose, onSaved }) {
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && row) {
      setRemark(parseCurrentRemark(row.remark));
      setError('');
    }
  }, [open, row?.id, row?.remark]);

  if (!open || !row) {
    return null;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      const updated = await adminApi.updateTransactionRemark({
        id: row.id,
        remark: remark.trim(),
      });
      onSaved?.(updated);
      onClose();
    } catch (err) {
      setError(err.message || '儲存失敗');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>修改備註</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <p className="page-desc">
              流水單號：<span className="mono-cell">{row.id}</span>
            </p>
            <p className="page-desc">儲存後會追加至備註歷程，列表顯示最新內容。</p>

            <div className="form-field">
              <label htmlFor="transactionRemarkInput">備註內容</label>
              <textarea
                id="transactionRemarkInput"
                rows={4}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="輸入要告知用戶的備註事項"
                autoFocus
              />
            </div>

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
              取消
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? '儲存中…' : '儲存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
